export function addCurrent(webchat) {
  return {
    type: 'ADD_CURRENT',
    webchat,
  }
}
